/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Button, useToast } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import TagInputField from '../../../components/form/TagInputField';
import c from '../../../constant';
import * as Yup from 'yup';
import { gql, useMutation } from '@apollo/client';

const M_TAGS = gql`
	mutation create($id: String!, $tags: [String!]) {
		saveTagsToNp(id: $id, tags: $tags) {
			id
		}
	}
`;

const validationSchema = Yup.object().shape({
	tags: Yup.array().of(Yup.string().required('required')).min(0),
});

function TagInputModal({ id = null, tags = [], isOpen = false, onClose = () => null, onCallback = () => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [save, { loading }] = useMutation(M_TAGS);

	return (
		<>
			<Modal size="2xl" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius} pb={4}>
					<ModalHeader>{tags?.length > 0 ? t('Edit') : t('Input')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							initialValues={{ tags }}
							validationSchema={validationSchema}
							onSubmit={(values) => {
								save({ variables: { id, tags: values?.tags || [] } })
									.then(({ data }) => {
										onClose();
										onCallback();
									})
									.catch((error) => {
										if (error?.graphQLErrors?.length > 0) {
											error?.graphQLErrors.map(({ message }, i) =>
												toast({
													title: t(message),
													status: 'error',
													isClosable: true,
													position: 'bottom-right',
												})
											);
										} else {
											toast({
												title: t(error?.message ? error?.message : 'something went wrong'),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											});
										}
									});
							}}
						>
							{(props) => (
								<Form>
									<TagInputField name="tags" label="Tag" />
									<Button
										id="login-btn"
										variant="solid"
										colorScheme="blue"
										size="md"
										h="42px"
										w="128px"
										mt={4}
										type="submit"
										borderRadius={c.borderRadius}
										isLoading={loading}
										float="right"
									>
										{t('Submit')}
									</Button>
								</Form>
							)}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

export default TagInputModal;
